module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "rt-notification-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    class: ['rt-notification', _vm.customClass, _vm.horizontalClass],
    style: (_vm.positionStyle),
    attrs: {
      "role": "alert"
    },
    on: {
      "mouseenter": function($event) {
        return _vm.clearTimer()
      },
      "mouseleave": function($event) {
        return _vm.startTimer()
      },
      "click": _vm.click
    }
  }, [(_vm.type || _vm.iconClass) ? _c('i', {
    staticClass: "rt-notification__icon",
    class: [_vm.typeClass, _vm.iconClass]
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "rt-notification__group",
    class: {
      'is-with-icon': _vm.typeClass || _vm.iconClass
    }
  }, [_c('div', {
    staticClass: "rt-header"
  }, [_vm._t("header-icon", function() {
    return [_c('rt-icon', {
      attrs: {
        "color": _vm.SCSS_VARIABLES.COLOR_NORMAL,
        "name": "rt-base-notification",
        "size": "16"
      }
    })]
  }), _vm._v(" "), _c('div', {
    staticClass: "rt-header__title"
  }, [_vm._v("\n          " + _vm._s(_vm.$tx('消息通知', 'xpc.common.messageNotification')) + "\n        ")]), _vm._v(" "), _c('rt-button', {
    attrs: {
      "icon-name": "rt-base-close",
      "type": "plain",
      "icon-size": "20",
      "color-type": "neutral-regular",
      "text": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.close.apply(null, arguments)
      }
    }
  })], 2), _vm._v(" "), _c('rt-divider'), _vm._v(" "), _c('div', {
    staticClass: "rt-content"
  }, [_c('div', {
    staticClass: "title-message",
    class: {
      'no-title': !_vm.title
    }
  }, [(_vm.title) ? _c('div', {
    staticClass: "rt-content__title"
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.message) ? _c('div', {
    staticClass: "rt-content__message"
  }, [_vm._v("\n            " + _vm._s(_vm.message) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "rt-content__operate"
  }, [_c('div', {
    staticClass: "operate-look"
  }, [_c('rt-button', {
    attrs: {
      "text": "",
      "type": "plain",
      "size": "small"
    },
    on: {
      "click": _vm.lookDetail
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$tx('查看', 'xpc.common.look')) + "\n            ")])], 1), _vm._v(" "), (_vm.showNext) ? _c('div', {
    staticClass: "operate-pageturn"
  }, [_c('rt-button', {
    attrs: {
      "text": "",
      "suffix-icon": "rt-base-arrow_right",
      "color-type": "neutral-secondary"
    },
    on: {
      "click": _vm.nextClick
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$tx('下一条', 'xpc.common.next')) + "\n            ")])], 1) : _vm._e()])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70375a2a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/notification/src/main.vue
// module id = 2119
// module chunks = 228